module.exports = __webpack_public_path__ + "img/public/AdminIcons/payoutIcon.svg?08add5d8";